import KeenSlider from 'keen-slider'
import Swiper from 'swiper'

function WheelControls(slider) {
  let touchTimeout;
  let position;
  let wheelActive;

  function dispatch(e, name) {
    position.x -= e.deltaX;
    slider.container.dispatchEvent(
      new CustomEvent(name, {
        detail: {
          x: position.x,
          y: position.y,
        },
      })
    );
  }

  function wheelStart(e) {
    position = {
      x: e.pageX,
      y: e.pageY,
    };
    dispatch(e, 'ksDragStart');
  }

  function wheel(e) {
    dispatch(e, 'ksDrag');
  }

  function wheelEnd(e) {
    dispatch(e, 'ksDragEnd');
  }

  function eventWheel(e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    if (!wheelActive) {
      wheelStart(e);
      wheelActive = true;
    }
    wheel(e);
    clearTimeout(touchTimeout);
    touchTimeout = setTimeout(() => {
      wheelActive = false;
      wheelEnd(e);
    }, 50);
  }

  slider.on('created', () => {
    slider.container.addEventListener('wheel', eventWheel, {
      passive: false,
    });
  });
}

if (!customElements.get('slider-component')) {
  class Slider extends HTMLElement {

    constructor() {
      super();
      this.sliderEl = this.querySelector('.keen-slider');
      this.prevButton = this.querySelector('[data-prev]') || document.querySelector(`[data-prev="${this.id}"]`);
      this.nextButton = this.querySelector('[data-next]') || document.querySelector(`[data-next="${this.id}"]`);
      this.dotsEl = this.querySelector('[data-dots]');
      this.options = this.getAttribute('options') ? JSON.parse(this.getAttribute('options')) : {};
      this.step = parseInt(this.getAttribute('data-step') || '1', 10);
    }

    connectedCallback() {
      this.slider = new KeenSlider(this.sliderEl, {
        ...this.options,
        rubberband: false,
      }, [WheelControls]);
      this.prevButton?.addEventListener('click', () => this.slider.prev(), false);
      this.nextButton?.addEventListener('click', () => this.slider.next(), false);

      if (this.dotsEl) {
        this.renderDots();
        this.slider.on('slideChanged', () => this.renderDots());
      }

      if (this.hasAttribute('data-autoplay')) {
        const interval = parseInt(this.getAttribute('data-autoplay') || '3000', 10);
        const advance = () => this.slider.moveToIdx(this.slider.track.details.rel + this.step);
        this.autoplayTimer = setInterval(advance, interval);
        this.addEventListener('mouseenter', () => clearInterval(this.autoplayTimer));
        this.addEventListener('mouseleave', () => {
          this.autoplayTimer = setInterval(advance, interval);
        });
      }
    }

    renderDots() {
      const slideCount = this.slider.track.details.slides.length;
      const current = this.slider.track.details.rel;
      const pageCount = Math.ceil(slideCount / this.step);
      const currentPage = Math.floor(current / this.step);
      this.dotsEl.innerHTML = '';
      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.ariaLabel = `Go to page ${i + 1}`;
        dot.className = `slider-dot${i === currentPage ? ' active' : ''}`;
        dot.addEventListener('click', () => this.slider.moveToIdx(i * this.step));
        this.dotsEl.appendChild(dot);
      }
    }

    disconnectedCallback() {
      clearInterval(this.autoplayTimer);
      this.slider?.destroy();
    }
  }
  customElements.define('slider-component', Slider);
}

if (!customElements.get('swiper-slider')) {
  class SwiperSlider extends HTMLElement {

    constructor() {
      super();
      this.sliderEl = this.querySelector('.swiper');
      this.prevButton = this.querySelector('[data-prev]') || document.querySelector(`[data-prev="${this.id}"]`);
      this.nextButton = this.querySelector('[data-next]') || document.querySelector(`[data-next="${this.id}"]`);
      this.options = this.getAttribute('options') ? JSON.parse(this.getAttribute('options')) : {};
      this.options.navigation = {
        prevEl: this.prevButton,
        nextEl: this.nextButton
      }
    }

    connectedCallback() {
      this.swiper = new Swiper(this.sliderEl, this.options);
      this.dots = this.querySelectorAll('[data-dot]');
      this.label = this.querySelector('[data-slide-label]');
      if (this.dots.length || this.label) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.swiper.slideToLoop(index));
        });
        this.swiper.on('slideChange', () => this.updatePagination());
        this.updatePagination();
      }
    }

    updatePagination() {
      const index = this.swiper.realIndex;
      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      if (this.label) {
        this.label.textContent = this.label.dataset.slideLabel.replace('{index}', index + 1);
      }
    }

    disconnectedCallback() {
      this.swiper?.destroy();
    }
  }
  customElements.define('swiper-slider', SwiperSlider);
}